import { useRef, useState } from "react";
import { DocumentDuplicateIcon, XMarkIcon } from "@heroicons/react/24/outline";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import CommonModal from "../CommonModal";
import SocialMediaIcons from "component/Referral/ExclusiveCode/SocialMediaIcons";

const ShareModal = ({
  inviteText,
  setShowShareModal = () => {},
  showShareModal = false,
  uncopiedClass = "bg-white text-black",
  copiedClass = "bg-white text-green",
  copyLabel = "Copy link",
}) => {
  const [copyText, setCopyText] = useState(false);
  const shareRef = useRef();

  const handleCopyMessage = async () => {
    try {
      await navigator.clipboard.writeText(inviteText);
      setCopyText(true);
    } catch (err) {}
  };

  const handleCloseShareModal = () => {
    setCopyText(false);
    setShowShareModal(false);
  };

  return (
    <CommonModal
      size="md"
      show={showShareModal}
      handleClose={() => handleCloseShareModal()}
      customClass="flex justify-center items-center min-h-screen w-full"
      customDialogModal="mx-4 my-10 flex-1 max-w-auto rounded-4xl overflow-hidden"
      customContentClass="h-auto rounded-4xl"
      customBodyClass="h-full bg-white rounded-4xl"
    >
      <div className="flex flex-col h-full" ref={shareRef}>
        <div className="flex items-center justify-between p-3 shadow-[0px_-4px_24px_0px_#0000001A] bg-white">
          <p className="ml-3 text-sm font-black">Share</p>
          <div
            onClick={handleCloseShareModal}
            className="flex justify-center w-8 h-8 rounded-full bg-grey-50 cursor-pointer"
          >
            <XMarkIcon className="w-6" />
          </div>
        </div>

        <div className="flex flex-col items-center justify-center gap-4 w-full">
          <SocialMediaIcons message={inviteText} />
          <div className="flex flex-col landing-md:flex-row items-center justify-center gap-4 mb-8 mx-auto px-4 w-full">
            <div className="flex justify-between items-center border bg-grey-50 rounded-xl p-2 overflow-hidden w-full">
              <div className="font-medium text-sm w-2/3 truncate pl-2 whitespace-nowrap">
                {inviteText}
              </div>
              <button
                onClick={handleCopyMessage}
                className={`flex items-center self-end gap-2 px-4 py-2 rounded-lg w-fit shrink-0 ${
                  copyText ? `${copiedClass} cursor-default` : `${uncopiedClass} cursor-pointer`
                }  text-sm font-medium`}
              >
                {copyText ? (
                  <DoneAllIcon className="w-5 h-5" />
                ) : (
                  <DocumentDuplicateIcon className="h-5 w-5 stroke-2" />
                )}
                {copyText ? "Copied" : copyLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

export default ShareModal;
